import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'semantic-ui-react'
import styled from 'styled-components'
import { CoolFarmDairyResultsType } from '~/api/services/coolFarm'

interface SummaryCardsProps {
  results: CoolFarmDairyResultsType
}

const SummaryCard = styled(Card)`
  text-align: center;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);

  .header {
    font-size: 1.2em !important;
    font-weight: 600;
    text-align: center !important;
    padding: 10px;
    display: block !important;
  }

  .value {
    font-size: 2.5em !important;
    font-weight: bold;
    margin: 10px 0;
  }

  .unit {
    font-size: 1em !important;
    opacity: 0.9;
  }
`

const safeParseFloat = (value: string | number | undefined): number => {
  if (value === undefined || value === null) return 0
  return parseFloat(String(value))
}

const formatNumber = (num: number) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'k'
  }
  return num.toFixed(2)
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ results }) => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-around' }}>
      <SummaryCard>
        <Card.Header className='header'>
          {t('Total emissions')}
        </Card.Header>
        <Card.Content>
          <div className='value'>
            {formatNumber(safeParseFloat(results.totalEmission))}
          </div>
          <div className='unit' dangerouslySetInnerHTML={{ __html: '<span>kg CO<sub>2</sub>e</span>' }}/>
        </Card.Content>
      </SummaryCard>
      <SummaryCard>
        <Card.Header className='header'>
          {t('Emissions per FPCM')}
        </Card.Header>
        <Card.Content>
          <div className='value'>
            {formatNumber(safeParseFloat(results.emissionPerFpcm))}
          </div>
          <div className='unit' dangerouslySetInnerHTML={{ __html: '<span>kg CO<sub>2</sub>e</span>' }}/>
        </Card.Content>
      </SummaryCard>
    </div>
  )
}

export default SummaryCards
